import { TableColumnsType } from "antd"
import { IGeoLevel } from "@/types/dags"
import { useGetGeoLevels } from "@/hooks/useDags"
import dayjs from "dayjs"
import TableCustom from "@components/table"

const GeoLevelPage = () => {
  const { data, isLoading } = useGetGeoLevels()

  const columns: TableColumnsType<IGeoLevel> = [
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "Description",
      key: "description",
      dataIndex: "description",
    },
    {
      title: "Code",
      key: "code",
      dataIndex: "code",
    },
    {
      title: "Join Code",
      key: "join_code",
      dataIndex: "join_code",
    },
    {
      title: "Join Name",
      key: "join_name",
      dataIndex: "join_name",
    },
    {
      title: "Geo Column",
      key: "geometry_column",
      dataIndex: "geometry_column",
    },
    {
      title: "Date Created",
      key: "dateCreated",
      dataIndex: "dateCreated",
      render: (text: Date) => dayjs(text).format("DD/MM/YYYY"),
    },
  ]

  return (
    <div>
      <TableCustom
        rowKey={"_id"}
        columns={columns}
        dataSource={data}
        loading={isLoading}
        size={"small"}
      />
    </div>
  )
}

export default GeoLevelPage
